import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config";
import "../../Pages/css/login.css";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
} from "react-bootstrap";
import * as ACTIONTYPES from "../../../redux/actionTypes";
import * as Yup from "yup";
import { Formik } from "formik";
import { Spin } from "antd";
import { ERROR, Success, Warning } from "../../../utils/errors";
import { userlogin,syncUser } from "../../../services/apiServices";
import { useDispatch } from "react-redux";
import { FaRegEye } from "react-icons/fa";

const LoadingPopup = () => {
  return (
    <div className="loading-popup-container">
      <div className="loading-popup">
        <p>Please wait</p>
        <h1>Loggin in . . .</h1>
      </div>
    </div>
  );
};

const UserLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showpass, setshowpass] = useState(false);
  const submitForm = async (values) => {
    // alert(1);
    setShowLoading(true);

    const payload = {
      emailAddress: values.userName,
      password: values.password,
    };
    try {
      const { data: response } = await userlogin(payload);
      setShowLoading(false);
      if (response.status) {
        response.data.isLogin = true;
        dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
        dispatch({
          type: ACTIONTYPES.USERLOGIN,
          payload: response.data,
          token: response?.data?.accessToken,
        });
        // Success(response.message)
        navigate(`${config.Exchange}`);
        //let at = response?.data?.accessToken
        //const data = await fetch(`https://launchpad.infimultichain.com/users/syncUser`, {
      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json',
      //     },
      //     body: JSON.stringify({
      //       accessToken: at,
      //     }),
      //   });
      //   //let xyz = await response.json();
      //   //console.log('aaaaa', xyz);
      //   console.log("abcd",data)
      // } else {
      //   Warning(response.message);
      // }
    } }
    catch (error) {
      setShowLoading(false);
      console.log("error", error);
      ERROR("Invalid email or password");
    }
  };

  const showPassword = (e) => {
    e.preventDefault();
    setshowpass(!showpass)
  }

  return (
    <>
      {/* <Header /> */}
      {/* <Header
        connectWalletNow={connectWalletNow}
        setconnectWalletNow={setconnectWalletNow}
      /> */}
      <section className="login-section ">
        <div className="login-container">
          <Container fluid className="px-0">
            <Row className="justify-content-center">
              <Col lg={12}>
                <Row className="">
                  <Col lg={6} md={6}  xs={12} className="">
                    <div className="login-form d-lg-block d-md-block d-none">
                      <div className="">
                        <img
                          src="assets/images/coinanimation3.png"
                          alt="logo"
                          className="coinsbackImg "
                        />
                        
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} md={6}  xs={12} className="">
                    <Spin spinning={showLoading}>
                      {/* <div className="loginDiv" style={{ minHeight: "368px" }}> */}
                      <div className="loginDiv">
                        <Row className="vh-100 align-items-center">
                          <Col lg={8} className="mx-auto">
                            <div className="form_content">
                              <div className="formDiv py-4">
                                <div className="text-center formheadbox">
                                  <h1 className="text-primary mb-2">
                                    Welcome Back!
                                  </h1>
                                  <p className="">
                                    You don't have an account &nbsp;
                                    <Link
                                      className="colorcode1 text-decoration-none"
                                      to={`${config.baseurl}signup`}
                                    >
                                      Signup
                                    </Link>
                                  </p>
                                  {/* <Button variant='default' className='px-4 bg-transparent border border-secondary'><Google className="me-2" />&nbsp;&nbsp;Sign up with Google</Button> */}
                                  {/* <div className="mb-4 pt-2">
                                    <Row>
                                      <Col lg={7} className="mx-auto">
                                        <Button
                                          variant=""
                                          type="button"
                                          className="googlebtn2 px-5 py-2"
                                        >
                                          <img
                                            src="assets/icons/GoogleIcon.svg"
                                            alt=" GoogleIcon"
                                            className=" Googleicon me-3"
                                            style={{
                                              width: "35px",
                                              height: "35px",
                                            }}
                                          />
                                          <span>Sign up with Google</span>
                                        </Button>
                                      </Col>
                                    </Row>
                                  </div> */}
                                  <div className="linetext mt-3 mb-3">Or</div>
                                </div>
                                <Formik
                                  initialValues={{
                                    userName: "",
                                    password: "",
                                  }}
                                  validationSchema={Yup.object().shape({
                                    userName: Yup.string()
                                      .nullable()
                                      .required("Please enter email"),
                                    password: Yup.string()
                                      .max(255)
                                      .required("Please enter password"),
                                  })}
                                  onSubmit={(values) => {
                                    submitForm(values);
                                  }}
                                >
                                  {({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    touched,
                                    values,
                                  }) => (
                                    <Form
                                      className="forms px-4"
                                      onSubmit={handleSubmit}
                                    >
                                      <div className="mb-3">
                                        <InputGroup className=" theme-input">
                                          <Form.Control
                                            placeholder="Email"
                                            aria-label="Username"
                                            aria-describedby="basic-addon1"
                                            error={Boolean(errors.userName)}
                                            // helperText={errors.userName}
                                            name="userName"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.userName}
                                            className="py-2"
                                          />
                                        </InputGroup>
                                        {errors.userName &&
                                          touched.userName && (
                                            <small
                                              className="required"
                                              style={{ color: "red" }}
                                            >
                                              {errors.userName}
                                            </small>
                                          )}
                                      </div>
                                      <div className="mb-3">
                                        <div className="input-field fieldbox px-0">
                                          <InputGroup className=" theme-input">
                                            <Form.Control
                                              type={`${showpass ? "name" : "password"}`}
                                              placeholder="Password"
                                              aria-label="Password"
                                              aria-describedby="basic-addon1"
                                              error={Boolean(errors.password)}
                                              helperText={errors.password}
                                              name='password'
                                              onBlur={handleBlur}
                                              onChange={handleChange}
                                              value={values.password}
                                              className="py-2 "
                                            />
                                          </InputGroup>
                                          <span className="me-3" onClick={showPassword}>
                                            <FaRegEye className="eyeIcon" />
                                          </span>
                                          {/* <span onClick={passwordicon === 0 ? (e) => showconfirmPassword(0) : (e) => showconfirmPassword(1)} className='eye-show-login'>
                                                                        {passwordicon === 0 ? <img height={15} src='icons/fa-fa-eye.png' /> : <img height={15} src='icons/fa fa-eye slash.png' />}</span> */}


                                        </div>
                                        {errors.password &&
                                          touched.password && (
                                            <small
                                              className="required"
                                              style={{ color: "red" }}
                                            >
                                              {errors.password}
                                            </small>
                                          )}
                                      </div>

                                      <div>
                                        <div className='promocodebox mt-3'>
                                          <Form className="d-flex justify-content-between">
                                            <Form.Group
                                              className="mb-0 checkbox"
                                              controlId="formBasicPassword"
                                            >
                                              {/* <p className="comment-form-cookies-consent mb-0">
                                                <input
                                                  id="default-checkbox"
                                                  name="agree"
                                                  type="checkbox"
                                                  checked={values.agree}
                                                  onBlur={handleBlur}
                                                  onChange={handleChange}
                                                  value={values.agree}
                                                />
                                              </p> */}
                                            </Form.Group>
                                            <div>
                                              <Link
                                                className="colorcode1 text-decoration-none"
                                                to={`${config.baseurl}forgotpassword`}
                                              >
                                                Forgot Password
                                              </Link>
                                            </div>
                                          </Form>
                                        </div>
                                      </div>
                                      {/* <div className="submit-btn mt-4">
																					<Button type='submit' variant='primary' className='w-100 text-black mb-3 fw-medium'>Log In</Button>
																				</div> */}

                                      {/* <Form.Group className="checkBox">
																					<Form.Check type="checkbox" />
																				</Form.Group> */}

                                      {/* <Form.Group
                                        className="mb-4 checkbox"
                                        controlId="formBasicPassword"
                                      >
                                        <p className="comment-form-cookies-consent">
                                          <input
                                            id="wp-comment-cookies-consent"
                                            name="wp-comment-cookies-consent"
                                            type="checkbox"
                                            defaultValue="yes"
                                          />
                                          <label htmlFor="wp-comment-cookies-consent">
                                            By signing up, I agree to the{" "}
                                            <a href="#">Privacy Policy</a> and{" "}
                                            <a href="#">Terms of Service</a>
                                          </label>
                                        </p>
                                      </Form.Group> */}

                                      <div className="text-center mt-3 ">
                                        <Button
                                          variant="custombtn2"
                                          className="py-2 w-100 fw-bold mb-3"
                                          type="submit"
                                        >
                                          Sign In
                                        </Button>

                                        {/* <Button
                                          variant="custombtn2"
                                          className="py-2 w-100 fw-bold"
                                          type="submit" href={`${config.baseurl}forgotpassword`}
                                        >
                                          Forgot Password
                                        </Button> */}
                                      </div>
                                    </Form>
                                  )}
                                </Formik>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Spin>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* <Footer /> */}
      {isLoading && <LoadingPopup />}
    </>
  );
};

export default UserLogin;
